import axiosInstance from './axiosInstance';

export const getProperties = () => axiosInstance.get('/api/dashboard/properties');
export const getProperty = (propertyId) => {
  return axiosInstance.get(`/api/dashboard/properties/${propertyId}`);
};
export const createProperty = (data) =>
  axiosInstance.post('/api/dashboard/properties', data);
export const updateProperty = (id, data) => axiosInstance.put(`/api/dashboard/properties/${id}`, data);
export const deleteProperty = (id, data) => axiosInstance.delete(`/api/dashboard/properties/${id}`, data);
